var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h17.788v17.788H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.368 8.557 2.456 2.455-.812.812-2.455-2.456a5.162 5.162 0 0 1-8.38-4.031 5.162 5.162 0 0 1 5.16-5.16 5.162 5.162 0 0 1 4.03 8.38zm-1.15-.425a4.012 4.012 0 0 0-2.881-6.809 4.012 4.012 0 0 0-4.014 4.014 4.012 4.012 0 0 0 6.809 2.88l.086-.085zM4.763 4.763H7.63V5.91H3.043V4.763h1.72z",
    fill: "#484848",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.b71716c447bdfcf44e3d1f6d2a65f0ed.svg";
export { ForwardRef as ReactComponent };